import { render, staticRenderFns } from "./EudrValidationDialog.vue?vue&type=template&id=21be07ea&scoped=true&"
import script from "./EudrValidationDialog.vue?vue&type=script&lang=js&"
export * from "./EudrValidationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EudrValidationDialog.vue?vue&type=style&index=0&id=21be07ea&prod&lang=css&"
import style1 from "./EudrValidationDialog.vue?vue&type=style&index=1&id=21be07ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be07ea",
  null
  
)

export default component.exports